export const taxonomyLevel3Values = [
  'Adapters & connectors',
  'Air conditioner parts & accessories',
  'Alexa gadgets',
  'Bases & stands',
  'Beverage refrigerator replacement parts',
  'Built-in dishwashers',
  'Controllers & remote controls',
  'Cooktop parts & accessories',
  'Countertop dishwashers',
  'Covers',
  'Dishwasher parts & accessories',
  'Dryer parts & accessories',
  'Fasteners',
  'Fire tv',
  'Food waste disposer parts & accessories',
  'Home security from amazon',
  'Portable dishwashers',
  'Power supplies & chargers',
  'Protection plans',
  'Skins',
  'Sleeves',
  'Trash compactors',
  'Washers & dryers'
];
